import AFG from '../assets/img/flags/AFG.png'
import ALB from '../assets/img/flags/ALB.png'
import DZA from '../assets/img/flags/DZA.png'
// import ASM from '../assets/img/flags/ASM.png'
import AND from '../assets/img/flags/AND.png'
import AGO from '../assets/img/flags/AGO.png'
// import AIA from '../assets/img/flags/AIA.png'
// import ATA from '../assets/img/flags/ATA.png'
import ATG from '../assets/img/flags/ATG.png'
import ARG from '../assets/img/flags/ARG.png'
import ARM from '../assets/img/flags/ARM.png'
// import ABW from '../assets/img/flags/ABW.png'
import AUS from '../assets/img/flags/AUS.png'
import AUT from '../assets/img/flags/AUT.png'
import AZE from '../assets/img/flags/AZE.png'
import BHS from '../assets/img/flags/BHS.png'
import BHR from '../assets/img/flags/BHR.png'
import BGD from '../assets/img/flags/BGD.png'
import BRB from '../assets/img/flags/BRB.png'
import BLR from '../assets/img/flags/BLR.png'
import BEL from '../assets/img/flags/BEL.png'
import BLZ from '../assets/img/flags/BLZ.png'
import BEN from '../assets/img/flags/BEN.png'
// import BMU from '../assets/img/flags/BMU.png'
import BTN from '../assets/img/flags/BTN.png'
import BOL from '../assets/img/flags/BOL.png'
import BIH from '../assets/img/flags/BIH.png'
import BWA from '../assets/img/flags/BWA.png'
import BRA from '../assets/img/flags/BRA.png'
// import IOT from '../assets/img/flags/IOT.png'
// import VGB from '../assets/img/flags/VGB.png'
import BRN from '../assets/img/flags/BRN.png'
import BGR from '../assets/img/flags/BGR.png'
import BFA from '../assets/img/flags/BFA.png'
import BDI from '../assets/img/flags/BDI.png'
import KHM from '../assets/img/flags/KHM.png'
import CMR from '../assets/img/flags/CMR.png'
import USA from '../assets/img/flags/USA.png'
// import CPV from '../assets/img/flags/CPV.png'
// import CYM from '../assets/img/flags/CYM.png'
import CAF from '../assets/img/flags/CAF.png'
import TCD from '../assets/img/flags/TCD.png'
import CHL from '../assets/img/flags/CHL.png'
import CHN from '../assets/img/flags/CHN.png'
// import CXR from '../assets/img/flags/CXR.png'
import COL from '../assets/img/flags/COL.png'
import COM from '../assets/img/flags/COM.png'
// import COK from '../assets/img/flags/COK.png'
import CRI from '../assets/img/flags/CRI.png'
import HRV from '../assets/img/flags/HRV.png'
import CUB from '../assets/img/flags/CUB.png'
// import CUW from '../assets/img/flags/CUW.png'
import CYP from '../assets/img/flags/CYP.png'
import CZE from '../assets/img/flags/CZE.png'
import COD from '../assets/img/flags/COD.png'
import DNK from '../assets/img/flags/DNK.png'
import DJI from '../assets/img/flags/DJI.png'
import DMA from '../assets/img/flags/DMA.png'
import DOM from '../assets/img/flags/DOM.png'
// import TLS from '../assets/img/flags/TLS.png'
import ECU from '../assets/img/flags/ECU.png'
import EGY from '../assets/img/flags/EGY.png'
import SLV from '../assets/img/flags/SLV.png'
import GNQ from '../assets/img/flags/GNQ.png'
import ERI from '../assets/img/flags/ERI.png'
import EST from '../assets/img/flags/EST.png'
import SWZ from '../assets/img/flags/SWZ.png'
import ETH from '../assets/img/flags/ETH.png'
// import FLK from '../assets/img/flags/FLK.png'
// import FRO from '../assets/img/flags/FRO.png'
import FJI from '../assets/img/flags/FJI.png'
import FIN from '../assets/img/flags/FIN.png'
import FRA from '../assets/img/flags/FRA.png'
// import PYF from '../assets/img/flags/PYF.png'
import GAB from '../assets/img/flags/GAB.png'
import GMB from '../assets/img/flags/GMB.png'
import GEO from '../assets/img/flags/GEO.png'
import DEU from '../assets/img/flags/DEU.png'
import GHA from '../assets/img/flags/GHA.png'
// import GIB from '../assets/img/flags/GIB.png'
import GRC from '../assets/img/flags/GRC.png'
// import GRL from '../assets/img/flags/GRL.png'
import GRD from '../assets/img/flags/GRD.png'
// import GUM from '../assets/img/flags/GUM.png'
import GTM from '../assets/img/flags/GTM.png'
// import GGY from '../assets/img/flags/GGY.png'
import GIN from '../assets/img/flags/GIN.png'
import GNB from '../assets/img/flags/GNB.png'
import GUY from '../assets/img/flags/GUY.png'
import HTI from '../assets/img/flags/HTI.png'
import HND from '../assets/img/flags/HND.png'
// import HKG from '../assets/img/flags/HKG.png'
import HUN from '../assets/img/flags/HUN.png'
import ISL from '../assets/img/flags/ISL.png'
import IND from '../assets/img/flags/IND.png'
import IDN from '../assets/img/flags/IDN.png'
import IRN from '../assets/img/flags/IRN.png'
import IRQ from '../assets/img/flags/IRQ.png'
import IRL from '../assets/img/flags/IRL.png'
// import IMN from '../assets/img/flags/IMN.png'
import ISR from '../assets/img/flags/ISR.png'
import ITA from '../assets/img/flags/ITA.png'
// import CIV from '../assets/img/flags/CIV.png'
import JAM from '../assets/img/flags/JAM.png'
import JPN from '../assets/img/flags/JPN.png'
// import JEY from '../assets/img/flags/JEY.png'
import JOR from '../assets/img/flags/JOR.png'
import KAZ from '../assets/img/flags/KAZ.png'
import KEN from '../assets/img/flags/KEN.png'
import KIR from '../assets/img/flags/KIR.png'
import XKX from '../assets/img/flags/XKX.png'
import KWT from '../assets/img/flags/KWT.png'
import KGZ from '../assets/img/flags/KGZ.png'
import LAO from '../assets/img/flags/LAO.png'
import LVA from '../assets/img/flags/LVA.png'
import LBN from '../assets/img/flags/LBN.png'
import LSO from '../assets/img/flags/LSO.png'
import LBR from '../assets/img/flags/LBR.png'
import LBY from '../assets/img/flags/LBY.png'
import LIE from '../assets/img/flags/LIE.png'
import LTU from '../assets/img/flags/LTU.png'
import LUX from '../assets/img/flags/LUX.png'
// import MAC from '../assets/img/flags/MAC.png'
import MDG from '../assets/img/flags/MDG.png'
import MWI from '../assets/img/flags/MWI.png'
import MYS from '../assets/img/flags/MYS.png'
import MDV from '../assets/img/flags/MDV.png'
import MLI from '../assets/img/flags/MLI.png'
import MLT from '../assets/img/flags/MLT.png'
import MHL from '../assets/img/flags/MHL.png'
import MRT from '../assets/img/flags/MRT.png'
import MUS from '../assets/img/flags/MUS.png'
// import MYT from '../assets/img/flags/MYT.png'
import MEX from '../assets/img/flags/MEX.png'
import FSM from '../assets/img/flags/FSM.png'
import MDA from '../assets/img/flags/MDA.png'
import MCO from '../assets/img/flags/MCO.png'
import MNG from '../assets/img/flags/MNG.png'
import MNE from '../assets/img/flags/MNE.png'
// import MSR from '../assets/img/flags/MSR.png'
import MAR from '../assets/img/flags/MAR.png'
import MOZ from '../assets/img/flags/MOZ.png'
import MMR from '../assets/img/flags/MMR.png'
import NAM from '../assets/img/flags/NAM.png'
import NRU from '../assets/img/flags/NRU.png'
import NPL from '../assets/img/flags/NPL.png'
import NLD from '../assets/img/flags/NLD.png'
// import ANT from '../assets/img/flags/ANT.png'
// import NCL from '../assets/img/flags/NCL.png'
import NZL from '../assets/img/flags/NZL.png'
import NIC from '../assets/img/flags/NIC.png'
import NER from '../assets/img/flags/NER.png'
import NGA from '../assets/img/flags/NGA.png'
// import NIU from '../assets/img/flags/NIU.png'
import PRK from '../assets/img/flags/PRK.png'
// import MNP from '../assets/img/flags/MNP.png'
import MKD from '../assets/img/flags/MKD.png'
import NOR from '../assets/img/flags/NOR.png'
import OMN from '../assets/img/flags/OMN.png'
import PAK from '../assets/img/flags/PAK.png'
import PLW from '../assets/img/flags/PLW.png'
import PSE from '../assets/img/flags/PSE.png'
import PAN from '../assets/img/flags/PAN.png'
import PNG from '../assets/img/flags/PNG.png'
import PRY from '../assets/img/flags/PRY.png'
import PER from '../assets/img/flags/PER.png'
import PHL from '../assets/img/flags/PHL.png'
// import PCN from '../assets/img/flags/PCN.png'
import POL from '../assets/img/flags/POL.png'
import PRT from '../assets/img/flags/PRT.png'
// import PRI from '../assets/img/flags/PRI.png'
import QAT from '../assets/img/flags/QAT.png'
import COG from '../assets/img/flags/COG.png'
// import REU from '../assets/img/flags/REU.png'
import ROU from '../assets/img/flags/ROU.png'
import RUS from '../assets/img/flags/RUS.png'
import RWA from '../assets/img/flags/RWA.png'
// import BLM from '../assets/img/flags/BLM.png'
// import SHN from '../assets/img/flags/SHN.png'
import KNA from '../assets/img/flags/KNA.png'
import LCA from '../assets/img/flags/LCA.png'
// import MAF from '../assets/img/flags/MAF.png'
// import SPM from '../assets/img/flags/SPM.png'
import VCT from '../assets/img/flags/VCT.png'
import WSM from '../assets/img/flags/WSM.png'
import SMR from '../assets/img/flags/SMR.png'
import STP from '../assets/img/flags/STP.png'
import SAU from '../assets/img/flags/SAU.png'
import SEN from '../assets/img/flags/SEN.png'
import SRB from '../assets/img/flags/SRB.png'
import SYC from '../assets/img/flags/SYC.png'
import SLE from '../assets/img/flags/SLE.png'
import SGP from '../assets/img/flags/SGP.png'
// import SXM from '../assets/img/flags/SXM.png'
import SVK from '../assets/img/flags/SVK.png'
import SVN from '../assets/img/flags/SVN.png'
import SLB from '../assets/img/flags/SLB.png'
import SOM from '../assets/img/flags/SOM.png'
import ZAF from '../assets/img/flags/ZAF.png'
import KOR from '../assets/img/flags/KOR.png'
import SSD from '../assets/img/flags/SSD.png'
import ESP from '../assets/img/flags/ESP.png'
import LKA from '../assets/img/flags/LKA.png'
import SDN from '../assets/img/flags/SDN.png'
import SUR from '../assets/img/flags/SUR.png'
// import SJM from '../assets/img/flags/SJM.png'
import SWE from '../assets/img/flags/SWE.png'
import CHE from '../assets/img/flags/CHE.png'
import SYR from '../assets/img/flags/SYR.png'
import TWN from '../assets/img/flags/TWN.png'
import TJK from '../assets/img/flags/TJK.png'
import TZA from '../assets/img/flags/TZA.png'
import THA from '../assets/img/flags/THA.png'
import TGO from '../assets/img/flags/TGO.png'
// import TKL from '../assets/img/flags/TKL.png'
import TON from '../assets/img/flags/TON.png'
import TTO from '../assets/img/flags/TTO.png'
import TUN from '../assets/img/flags/TUN.png'
import TUR from '../assets/img/flags/TUR.png'
import TKM from '../assets/img/flags/TKM.png'
// import TCA from '../assets/img/flags/TCA.png'
import TUV from '../assets/img/flags/TUV.png'
// import VIR from '../assets/img/flags/VIR.png'
import UGA from '../assets/img/flags/UGA.png'
import UKR from '../assets/img/flags/UKR.png'
import ARE from '../assets/img/flags/ARE.png'
import GBR from '../assets/img/flags/GBR.png'
import URY from '../assets/img/flags/URY.png'
import UZB from '../assets/img/flags/UZB.png'
import VUT from '../assets/img/flags/VUT.png'
import VAT from '../assets/img/flags/VAT.png'
import VEN from '../assets/img/flags/VEN.png'
import VNM from '../assets/img/flags/VNM.png'
// import WLF from '../assets/img/flags/WLF.png'
// import ESH from '../assets/img/flags/ESH.png'
import YEM from '../assets/img/flags/YEM.png'
import ZMB from '../assets/img/flags/ZMB.png'
import ZWE from '../assets/img/flags/ZWE.png'

let country_codes = new Map()

country_codes.set('93', { src: AFG, name: 'Afghanistan' })
country_codes.set('355', { src: ALB, name: 'Albania' })
country_codes.set('213', { src: DZA, name: 'Algeria' })
country_codes.set('1684', { src: USA, name: 'American Samoa' })
country_codes.set('376', { src: AND, name: 'Andorra' })
country_codes.set('244', { src: AGO, name: 'Angola' })
country_codes.set('1264', { src: GBR, name: 'Anguilla' })
country_codes.set('1-268', { src: ATG, name: 'Antigua and Barbuda' })
country_codes.set('54', { src: ARG, name: 'Argentina' })
country_codes.set('374', { src: ARM, name: 'Armenia' })
country_codes.set('297', { src: NLD, name: 'Aruba' })
country_codes.set('61', { src: AUS, name: 'Australia' })
country_codes.set('43', { src: AUT, name: 'Austria' })
country_codes.set('994', { src: AZE, name: 'Azerbaijan' })
country_codes.set('1-242', { src: BHS, name: 'Bahamas' })
country_codes.set('973', { src: BHR, name: 'Bahrain' })
country_codes.set('880', { src: BGD, name: 'Bangladesh' })
country_codes.set('1-246', { src: BRB, name: 'Barbados' })
country_codes.set('375', { src: BLR, name: 'Belarus' })
country_codes.set('32', { src: BEL, name: 'Belgium' })
country_codes.set('501', { src: BLZ, name: 'Belize' })
country_codes.set('229', { src: BEN, name: 'Benin' })
country_codes.set('1441', { src: GBR, name: 'Bermuda' })
country_codes.set('975', { src: BTN, name: 'Bhutan' })
country_codes.set('591', { src: BOL, name: 'Bolivia' })
country_codes.set('387', { src: BIH, name: 'Bosnia and Herzegovina' })
country_codes.set('267', { src: BWA, name: 'Botswana' })
country_codes.set('55', { src: BRA, name: 'Brazil' })
country_codes.set('246', { src: GBR, name: 'British Indian Ocean Territory' })
country_codes.set('1284', { src: GBR, name: 'British Virgin Islands' })
country_codes.set('673', { src: BRN, name: 'Brunei' })
country_codes.set('359', { src: BGR, name: 'Bulgaria' })
country_codes.set('226', { src: BFA, name: 'Burkina Faso' })
country_codes.set('257', { src: BDI, name: 'Burundi' })
country_codes.set('855', { src: KHM, name: 'Cambodia' })
country_codes.set('237', { src: CMR, name: 'Cameroon' })
// country_codes.set('238', { src: CPV, name: 'Cape Verde' })
// country_codes.set('1345', { src: CYM, name: 'Cayman Islands' })
country_codes.set('236', { src: CAF, name: 'Central African Republic' })
country_codes.set('235', { src: TCD, name: 'Chad' })
country_codes.set('56', { src: CHL, name: 'Chile' })
country_codes.set('86', { src: CHN, name: 'China' })
country_codes.set('61', { src: AUS, name: 'Christmas Island' })
country_codes.set('57', { src: COL, name: 'Colombia' })
country_codes.set('269', { src: COM, name: 'Comoros' })
country_codes.set('682', { src: NZL, name: 'Cook Islands' })
country_codes.set('506', { src: CRI, name: 'Costa Rica' })
country_codes.set('385', { src: HRV, name: 'Croatia' })
country_codes.set('53', { src: CUB, name: 'Cuba' })
country_codes.set('599', { src: NLD, name: 'Curacao' })
country_codes.set('357', { src: CYP, name: 'Cyprus' })
country_codes.set('420', { src: CZE, name: 'Czech Republic' })
country_codes.set('243', { src: COD, name: 'Democratic Republic of the Congo' })
country_codes.set('45', { src: DNK, name: 'Denmark' })
country_codes.set('253', { src: DJI, name: 'Djibouti' })
country_codes.set('1-767', { src: DMA, name: 'Dominica' })
country_codes.set('1-809', { src: DOM, name: 'Dominican Republic' })
country_codes.set('1-829', { src: DOM, name: 'Dominican Republic' })
country_codes.set('1-849', { src: DOM, name: 'Dominican Republic' })
country_codes.set('670', { src: IDN, name: 'East Timor' })
country_codes.set('593', { src: ECU, name: 'Ecuador' })
country_codes.set('20', { src: EGY, name: 'Egypt' })
country_codes.set('503', { src: SLV, name: 'El Salvador' })
country_codes.set('240', { src: GNQ, name: 'Equatorial Guinea' })
country_codes.set('291', { src: ERI, name: 'Eritrea' })
country_codes.set('372', { src: EST, name: 'Estonia' })
country_codes.set('268', { src: SWZ, name: 'Eswatini' })
country_codes.set('251', { src: ETH, name: 'Ethiopia' })
country_codes.set('500', { src: GBR, name: 'Falkland Islands' })
country_codes.set('298', { src: DNK, name: 'Faroe Islands' })
country_codes.set('679', { src: FJI, name: 'Fiji' })
country_codes.set('358', { src: FIN, name: 'Finland' })
country_codes.set('33', { src: FRA, name: 'France' })
country_codes.set('689', { src: FRA, name: 'French Polynesia' })
country_codes.set('241', { src: GAB, name: 'Gabon' })
country_codes.set('220', { src: GMB, name: 'Gambia' })
country_codes.set('995', { src: GEO, name: 'Georgia' })
country_codes.set('49', { src: DEU, name: 'Germany' })
country_codes.set('233', { src: GHA, name: 'Ghana' })
country_codes.set('350', { src: GBR, name: 'Gibraltar' })
country_codes.set('30', { src: GRC, name: 'Greece' })
country_codes.set('299', { src: DNK, name: 'Greenland' })
country_codes.set('1-473', { src: GRD, name: 'Grenada' })
country_codes.set('1671', { src: USA, name: 'Guam' })
country_codes.set('502', { src: GTM, name: 'Guatemala' })
country_codes.set('44-1481', { src: GBR, name: 'Guernsey' })
country_codes.set('224', { src: GIN, name: 'Guinea' })
country_codes.set('245', { src: GNB, name: 'Guinea bissau' })
country_codes.set('592', { src: GUY, name: 'Guyana' })
country_codes.set('509', { src: HTI, name: 'Haiti' })
country_codes.set('504', { src: HND, name: 'Honduras' })
country_codes.set('852', { src: CHN, name: 'Hong Kong' })
country_codes.set('36', { src: HUN, name: 'Hungary' })
country_codes.set('354', { src: ISL, name: 'Iceland' })
country_codes.set('91', { src: IND, name: 'India' })
country_codes.set('62', { src: IDN, name: 'Indonesia' })
country_codes.set('98', { src: IRN, name: 'Iran' })
country_codes.set('964', { src: IRQ, name: 'Iraq' })
country_codes.set('353', { src: IRL, name: 'Ireland' })
// country_codes.set('44-1624', { src: IMN, name: 'Isle of Man' })
country_codes.set('972', { src: ISR, name: 'Israel' })
country_codes.set('39', { src: ITA, name: 'Italy' })
// country_codes.set('225', { src: CIV, name: 'Ivory Coast' })
country_codes.set('1-876', { src: JAM, name: 'Jamaica' })
country_codes.set('81', { src: JPN, name: 'Japan' })
country_codes.set('44-1534', { src: GBR, name: 'Jersey' })
country_codes.set('962', { src: JOR, name: 'Jordan' })
country_codes.set('7', { src: KAZ, name: 'Kazakhstan' })
country_codes.set('254', { src: KEN, name: 'Kenya' })
country_codes.set('686', { src: KIR, name: 'Kiribati' })
country_codes.set('383', { src: XKX, name: 'Kosovo' })
country_codes.set('965', { src: KWT, name: 'Kuwait' })
country_codes.set('996', { src: KGZ, name: 'Kyrgyzstan' })
country_codes.set('856', { src: LAO, name: 'Laos' })
country_codes.set('371', { src: LVA, name: 'Latvia' })
country_codes.set('961', { src: LBN, name: 'Lebanon' })
country_codes.set('266', { src: LSO, name: 'Lesotho' })
country_codes.set('231', { src: LBR, name: 'Liberia' })
country_codes.set('218', { src: LBY, name: 'Libya' })
country_codes.set('423', { src: LIE, name: 'Liechtenstein' })
country_codes.set('370', { src: LTU, name: 'Lithuania' })
country_codes.set('352', { src: LUX, name: 'Luxembourg' })
country_codes.set('853', { src: CHN, name: 'Macau' })
country_codes.set('261', { src: MDG, name: 'Madagascar' })
country_codes.set('265', { src: MWI, name: 'Malawi' })
country_codes.set('60', { src: MYS, name: 'Malaysia' })
country_codes.set('960', { src: MDV, name: 'Maldives' })
country_codes.set('223', { src: MLI, name: 'Mali' })
country_codes.set('356', { src: MLT, name: 'Malta' })
country_codes.set('692', { src: MHL, name: 'Marshall Islands' })
country_codes.set('222', { src: MRT, name: 'Mauritania' })
country_codes.set('230', { src: MUS, name: 'Mauritius' })
country_codes.set('262', { src: FRA, name: 'Mayotte' })
country_codes.set('52', { src: MEX, name: 'Mexico' })
country_codes.set('691', { src: FSM, name: 'Micronesia' })
country_codes.set('373', { src: MDA, name: 'Moldova' })
country_codes.set('377', { src: MCO, name: 'Monaco' })
country_codes.set('976', { src: MNG, name: 'Mongolia' })
country_codes.set('382', { src: MNE, name: 'Montenegro' })
country_codes.set('1664', { src: GBR, name: 'Montserrat' })
country_codes.set('212', { src: MAR, name: 'Morocco' })
country_codes.set('258', { src: MOZ, name: 'Mozambique' })
country_codes.set('95', { src: MMR, name: 'Myanmar' })
country_codes.set('264', { src: NAM, name: 'Namibia' })
country_codes.set('674', { src: NRU, name: 'Nauru' })
country_codes.set('977', { src: NPL, name: 'Nepal' })
country_codes.set('31', { src: NLD, name: 'Netherlands' })
country_codes.set('599', { src: NLD, name: 'Netherlands Antilles' })
country_codes.set('687', { src: FRA, name: 'New Caledonia' })
country_codes.set('64', { src: NZL, name: 'New Zealand' })
country_codes.set('505', { src: NIC, name: 'Nicaragua' })
country_codes.set('227', { src: NER, name: 'Niger' })
country_codes.set('234', { src: NGA, name: 'Nigeria' })
country_codes.set('683', { src: NZL, name: 'Niue' })
country_codes.set('850', { src: PRK, name: 'North Korea' })
country_codes.set('1670', { src: USA, name: 'Northern Mariana Islands' })
country_codes.set('389', { src: MKD, name: 'North Macedonia' })
country_codes.set('47', { src: NOR, name: 'Norway' })
country_codes.set('968', { src: OMN, name: 'Oman' })
country_codes.set('92', { src: PAK, name: 'Pakistan' })
country_codes.set('680', { src: PLW, name: 'Palau' })
country_codes.set('970', { src: PSE, name: 'Palestine' })
country_codes.set('507', { src: PAN, name: 'Panama' })
country_codes.set('675', { src: PNG, name: 'Papau New Guinea' })
country_codes.set('595', { src: PRY, name: 'Paraguay' })
country_codes.set('51', { src: PER, name: 'Peru' })
country_codes.set('63', { src: PHL, name: 'Phillippines' })
country_codes.set('64', { src: GBR, name: 'Pitcairn' })
country_codes.set('48', { src: POL, name: 'Poland' })
country_codes.set('351', { src: PRT, name: 'Portugal' })
country_codes.set('1787', { src: USA, name: 'Puerto Rico' })
country_codes.set('1939', { src: USA, name: 'Puerto Rico' })
country_codes.set('974', { src: QAT, name: 'Qatar' })
country_codes.set('242', { src: COG, name: 'Republic of the Congo' })
country_codes.set('262', { src: FRA, name: 'Reunion' })
country_codes.set('40', { src: ROU, name: 'Romania' })
country_codes.set('7', { src: RUS, name: 'Russia' })
country_codes.set('250', { src: RWA, name: 'Rwanda' })
country_codes.set('590', { src: FRA, name: 'Saint Barthelemy' })
country_codes.set('290', { src: GBR, name: 'Saint  Helena' })
country_codes.set('1-869', { src: KNA, name: 'Saint Kitts and Nevis' })
country_codes.set('1-758', { src: LCA, name: 'Saint Lucia' })
country_codes.set('590', { src: FRA, name: 'Saint Martin' })
country_codes.set('508', { src: FRA, name: 'Saint Pierre and Miquelon' })
country_codes.set('1-784', { src: VCT, name: 'Saint Vincent and the Grenadines' })
country_codes.set('685', { src: WSM, name: 'Samoa' })
country_codes.set('378', { src: SMR, name: 'San Marino' })
country_codes.set('239', { src: STP, name: 'Sao Tome and Principe' })
country_codes.set('966', { src: SAU, name: 'Saudi Arabia' })
country_codes.set('221', { src: SEN, name: 'Senegal' })
country_codes.set('381', { src: SRB, name: 'Serbia' })
country_codes.set('248', { src: SYC, name: 'Seychelles' })
country_codes.set('232', { src: SLE, name: 'Sierra Leone' })
country_codes.set('65', { src: SGP, name: 'Singapore' })
country_codes.set('1721', { src: NLD, name: 'Sint Maarten' })
country_codes.set('421', { src: SVK, name: 'Slovakia' })
country_codes.set('386', { src: SVN, name: 'Slovenia' })
country_codes.set('677', { src: SLB, name: 'Solomon Islands' })
country_codes.set('252', { src: SOM, name: 'Somalia' })
country_codes.set('27', { src: ZAF, name: 'South Africa' })
country_codes.set('82', { src: KOR, name: 'South Korea' })
country_codes.set('211', { src: SSD, name: 'South Sudan' })
country_codes.set('34', { src: ESP, name: 'Spain' })
country_codes.set('94', { src: LKA, name: 'Sri Lanka' })
country_codes.set('249', { src: SDN, name: 'Sudan' })
country_codes.set('597', { src: SUR, name: 'Suriname' })
country_codes.set('47', { src: NOR, name: 'Svalbard and Jan Mayen' })
country_codes.set('46', { src: SWE, name: 'Sweden' })
country_codes.set('41', { src: CHE, name: 'Switzerland' })
country_codes.set('963', { src: SYR, name: 'Syria' })
country_codes.set('886', { src: TWN, name: 'Taiwan' })
country_codes.set('992', { src: TJK, name: 'Tajikistan' })
country_codes.set('255', { src: TZA, name: 'Tanzania' })
country_codes.set('66', { src: THA, name: 'Thailand' })
country_codes.set('228', { src: TGO, name: 'Togo' })
country_codes.set('690', { src: NZL, name: 'Tokelau' })
country_codes.set('676', { src: TON, name: 'Tonga' })
country_codes.set('1-868', { src: TTO, name: 'Trinidad and Tobago' })
country_codes.set('216', { src: TUN, name: 'Tunisia' })
country_codes.set('90', { src: TUR, name: 'Turkey' })
country_codes.set('993', { src: TKM, name: 'Turkmenistan' })
country_codes.set('1649', { src: GBR, name: 'Turks and Caicos Islands' })
country_codes.set('688', { src: TUV, name: 'Tuvalu' })
country_codes.set('1340', { src: USA, name: 'U.S. Virgin Islands' })
country_codes.set('256', { src: UGA, name: 'Uganda' })
country_codes.set('380', { src: UKR, name: 'Ukraine' })
country_codes.set('971', { src: ARE, name: 'United Arab Emirates' })
country_codes.set('44', { src: GBR, name: 'United Kingdom' })
country_codes.set('1', { src: USA, name: 'United States' })
country_codes.set('598', { src: URY, name: 'Uruguay' })
country_codes.set('998', { src: UZB, name: 'Uzbekistan' })
country_codes.set('678', { src: VUT, name: 'Vanuatu' })
country_codes.set('379', { src: VAT, name: 'Vatican' })
country_codes.set('58', { src: VEN, name: 'Venezuala' })
country_codes.set('84', { src: VNM, name: 'Vietnam' })
country_codes.set('681', { src: FRA, name: 'Wallis and Futuna' })
country_codes.set('212', { src: MAR, name: 'Western Sarah' })
country_codes.set('967', { src: YEM, name: 'Yemen' })
country_codes.set('260', { src: ZMB, name: 'Zambia' })
country_codes.set('263', { src: ZWE, name: 'Zimbabwe' })

export default country_codes